import HonoraiosApi from '../../apis/Honorarios';

export default {
    namespaced: true,
    state: {
        recibos: []
    },
    mutations: {
        set_honorarios (state, recibos) {
            state.recibos = recibos;
        }
    },
    actions: {
        async getHonorarios ({commit, dispatch}, filter) {
            return await HonoraiosApi.get_all(filter)
                            .then( response => {
                                commit('set_honorarios', response.data)
                            })
                            .catch(error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al listar registros, vuelva a intentarlo.'
                                })
                            })
        }
    }
}